"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCustomizedComponents = getCustomizedComponents;
var _Accordion = require("./customize/Accordion.customize");
var _Alert = require("./customize/Alert.customize");
var _Avatar = require("./customize/Avatar.customize");
var _Button = require("./customize/Button.customize");
var _ButtonGroup = require("./customize/ButtonGroup.customize");
var _Checkbox = require("./customize/Checkbox.customize");
var _Chip = require("./customize/Chip.customize");
var _Pagination = require("./customize/Pagination.customize");
var _ProgressBar = require("./customize/ProgressBar.customize");
var _Radio = require("./customize/Radio.customize");
var _Slider = require("./customize/Slider.customize");
var _Skeleton = require("./customize/Skeleton.customize");
var _Switch = require("./customize/Switch.customize");
var _Tab = require("./customize/Tab.customize");
var _Tabs = require("./customize/Tabs.customize");
var _TextField = require("./customize/TextField.customize");
var _Tooltip = require("./customize/Tooltip.customize");
var _Typography = require("./customize/Typography.customize");
/* eslint-disable import/max-dependencies */

// Include MuiDataGrid in the theme https://github.com/mui-org/material-ui-x/issues/1755

// Export components
function getCustomizedComponents() {
  return {
    MuiAccordion: (0, _Accordion.getMuiAccordion)(),
    MuiAccordionSummary: (0, _Accordion.getMuiAccordionSummary)(),
    MuiAlert: (0, _Alert.getMuiAlert)(),
    MuiAvatar: (0, _Avatar.getMuiAvatar)(),
    MuiButton: (0, _Button.getMuiButton)(),
    MuiButtonBase: (0, _Button.getMuiButtonBase)(),
    MuiButtonGroup: (0, _ButtonGroup.getMuiButtonGroup)(),
    MuiCheckbox: (0, _Checkbox.getMuiCheckbox)(),
    MuiChip: (0, _Chip.getMuiChip)(),
    MuiLinearProgress: (0, _ProgressBar.getMuiProgressBar)(),
    MuiPagination: (0, _Pagination.getMuiPagination)(),
    MuiRadio: (0, _Radio.getMuiRadio)(),
    MuiSkeleton: (0, _Skeleton.getMuiSkeleton)(),
    MuiSlider: (0, _Slider.getMuiSlider)(),
    MuiSwitch: (0, _Switch.getMuiSwitch)(),
    MuiTab: (0, _Tab.getMuiTab)(),
    MuiTabs: (0, _Tabs.getMuiTabs)(),
    MuiTextField: (0, _TextField.getMuiTextField)(),
    MuiTooltip: (0, _Tooltip.getMuiTooltip)(),
    MuiTypography: (0, _Typography.getMuiTypography)()
  };
}